import React from 'react';
import { connect } from 'react-redux';
import HtmlToReact from 'html-to-react';

let htmlToReactParser = new HtmlToReact.Parser(React);

import {
  getOfferDescription,
} from '../../reducers/ProductReducers';

const DescriptionBlock = ({ description }) => {
  return (
    <div>
      { description ?
        <div className="offer-container push--top">
          <div className="offer__description-block">
            <div className="offer__description--heading font-rc caps">
              <span style={{ borderBottom: '2px solid #3694D0' }}>Description</span>
            </div>
            <div className="soft--top paragraph">
              {htmlToReactParser.parse(`<div class="offer__description--content">${description}</div>`)}
            </div>
          </div>
        </div> :
        null
      }
    </div>
  );
};

const mapStateToProps = ({ product }) => ({
  description: getOfferDescription(product),
});

export default connect(mapStateToProps)(DescriptionBlock);



// WEBPACK FOOTER //
// ./src/product/views/_layout/DescriptionBlock.js